import React, { memo } from "react";
import { SelectVisitCount } from "./SelectVisitCount";
import { useLineSegmentMsgForm } from "../../../../hooks/externalApi/line/useLineSegmentMsgForm";
import { useLineSegmentMsgSubmit } from "../../../../hooks/externalApi/line/useLineSegmentMsgSubmit";
import { LineDeliverySampleImages } from "../../../molecules/LineDeliverySampleImages";
import { SubmitBtn } from "../../../atoms/button/SubmitBtn";
import { Box, CardBody, CardFooter, CardHeader, VStack } from "@chakra-ui/react";
import { LabelInput } from "./LabelInput";
import { UrlInput } from "./UrlInput";
import { TextTextarea } from "./TextTextarea";
import { TitleTextarea } from "./TitleTextarea";
import { AltTextTextarea } from "./AltTextTextarea";
import { TextMsgTextarea } from "./TextMsgTextarea";
import { ImgInput } from "./ImgInput";
import { DarkShadowCard } from "../../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../../molecules/card/CardHeading";
import { IoSend } from "react-icons/io5";


type LineSegmentMsgFormProps = {
  restaurantId: string
  accessToken: string
}
const formComponents = [
  TextMsgTextarea,
  ImgInput,
  AltTextTextarea,
  TitleTextarea,
  TextTextarea,
  LabelInput,
  UrlInput,
];
export const LineSegmentMsgForm: React.FC<LineSegmentMsgFormProps> = memo(({restaurantId, accessToken}) => {
  const { handleSubmit, errors, control, register, reset, isSubmitting } = useLineSegmentMsgForm();
  const { onSubmit } = useLineSegmentMsgSubmit(restaurantId, accessToken, reset);
  return (
    <Box as="form" onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" w={{base: '100%', lg: '810px'}}>
      <DarkShadowCard>
        <CardHeader>
          <CardHeading icon={<IoSend size="20px" />} heading='メッセージ配信'/>
        </CardHeader>
        <CardBody py={2}>
          <VStack align='start' spacing={{base: 6, sm: 8}} w='100%'>
            <LineDeliverySampleImages />
            {/*来店回数*/}
            <SelectVisitCount control={control} errors={errors} restaurantId={restaurantId} />
            {/*来店回数以降の項目*/}
            {formComponents.map((Component, index) => (
              <Component key={index} register={register} errors={errors} />
            ))}
          </VStack>
        </CardBody>
        <CardFooter>
          <SubmitBtn isLoading={isSubmitting}>配信</SubmitBtn>
        </CardFooter>
      </DarkShadowCard>
    </Box>
  );
});